
    import {Component, Prop, Vue} from 'vue-property-decorator';

    @Component({})
    export default class BrowserWindow extends Vue {
        @Prop() private title!: string;
    }
